import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect, useState } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $isHeadingNode } from "@lexical/rich-text";
import { $getSelection, $isRangeSelection, COMMAND_PRIORITY_LOW, SELECTION_CHANGE_COMMAND } from "lexical";
import { mergeRegister } from "@lexical/utils";
import { $getSelectionStyleValueForProperty } from "@lexical/selection";
import { useTheme } from "@mui/material/styles";
import { Box } from "../../../../Box/index.js";
import { DropdownButton } from "../../../../DropdownButton/index.js";
import { Typography } from "../../../../Typography/index.js";
import { Icon } from "../../../../Icon/index.js";
import { ToolbarButton } from "../common/index.js";
import { blockTypeToBlockName, useBgColorsItems, useColorsItems, useTagsItems } from "./hooks/index.js";
const FormatHeadingPlugin = (t0)=>{
    const $ = c(25);
    const { heading, fontColor, backgroungColor } = t0;
    const theme = useTheme();
    const [editor] = useLexicalComposerContext();
    const [selectedBlockType, setSelectedBlockType] = useState("paragraph");
    const [selectedColorType, setSelectedColorType] = useState(theme.tokens.colors.text.light.primary);
    const [selectedBgColorType, setSelectedBgColorType] = useState(theme.tokens.colors.bg.light.primary);
    const [isBgColorApplyed, setIsBgColorApplyed] = useState(false);
    const tags = useTagsItems(editor, selectedBlockType);
    const colors = useColorsItems(editor, selectedColorType);
    const bgColors = useBgColorsItems(editor, selectedBgColorType);
    let t1;
    if ($[0] !== editor || $[1] !== theme.tokens.colors.bg.light.primary || $[2] !== theme.tokens.colors.text.light.primary) {
        t1 = ()=>{
            const selection = $getSelection();
            if ($isRangeSelection(selection)) {
                const anchorNode = selection.anchor.getNode();
                const element = "root" === anchorNode.getKey() ? anchorNode : anchorNode.getTopLevelElementOrThrow();
                const elementKey = element.getKey();
                const elementDOM = editor.getElementByKey(elementKey);
                if (null !== elementDOM) {
                    const type = $isHeadingNode(element) ? element.getTag() : element.getType();
                    if (type in blockTypeToBlockName) setSelectedBlockType(type);
                }
                const currentColor = $getSelectionStyleValueForProperty(selection, "color", theme.tokens.colors.text.light.primary);
                if (currentColor) setSelectedColorType(currentColor);
                const defaultBgColor = theme.tokens.colors.bg.light.primary;
                const currentBgColor = $getSelectionStyleValueForProperty(selection, "background-color", defaultBgColor);
                if (currentBgColor) {
                    setIsBgColorApplyed(()=>currentBgColor !== defaultBgColor);
                    setSelectedBgColorType(currentBgColor);
                }
            }
        };
        $[0] = editor;
        $[1] = theme.tokens.colors.bg.light.primary;
        $[2] = theme.tokens.colors.text.light.primary;
        $[3] = t1;
    } else t1 = $[3];
    const updateToolbar = t1;
    let t2;
    let t3;
    if ($[4] !== editor || $[5] !== updateToolbar) {
        t2 = ()=>mergeRegister(editor.registerUpdateListener((t4)=>{
                const { editorState } = t4;
                editorState.read(()=>{
                    updateToolbar();
                });
            }), editor.registerCommand(SELECTION_CHANGE_COMMAND, ()=>{
                updateToolbar();
                return false;
            }, COMMAND_PRIORITY_LOW));
        t3 = [
            editor,
            updateToolbar
        ];
        $[4] = editor;
        $[5] = updateToolbar;
        $[6] = t2;
        $[7] = t3;
    } else {
        t2 = $[6];
        t3 = $[7];
    }
    useEffect(t2, t3);
    let t4;
    if ($[8] !== heading || $[9] !== selectedBlockType || $[10] !== tags) {
        t4 = heading && /*#__PURE__*/ jsx(DropdownButton, {
            menuItems: tags,
            variant: "tertiaryLight",
            verticalPosition: "bottom",
            horizontalPosition: "left",
            button: (t5)=>{
                const { onClick } = t5;
                return /*#__PURE__*/ jsx(ToolbarButton, {
                    onClick: onClick,
                    tooltip: "\u0421\u0442\u0438\u043B\u0438 \u0442\u0435\u043A\u0441\u0442\u0430",
                    children: /*#__PURE__*/ jsxs(Box, {
                        display: "flex",
                        alignItems: "center",
                        gap: "4",
                        children: [
                            /*#__PURE__*/ jsx(Typography, {
                                variant: "caption",
                                children: blockTypeToBlockName[selectedBlockType]
                            }),
                            /*#__PURE__*/ jsx(Icon, {
                                name: "dropdown",
                                size: "16",
                                color: "text.light.primary"
                            })
                        ]
                    })
                });
            }
        });
        $[8] = heading;
        $[9] = selectedBlockType;
        $[10] = tags;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== colors || $[13] !== fontColor || $[14] !== selectedColorType) {
        t5 = fontColor && /*#__PURE__*/ jsx(DropdownButton, {
            menuItems: colors,
            variant: "tertiaryLight",
            verticalPosition: "bottom",
            horizontalPosition: "left",
            button: (t6)=>{
                const { onClick: onClick_0 } = t6;
                return /*#__PURE__*/ jsx(ToolbarButton, {
                    onClick: onClick_0,
                    tooltip: "\u0426\u0432\u0435\u0442 \u0442\u0435\u043A\u0441\u0442\u0430",
                    children: /*#__PURE__*/ jsxs(Box, {
                        display: "flex",
                        alignItems: "center",
                        gap: "4",
                        children: [
                            /*#__PURE__*/ jsx(Box, {
                                width: "16px",
                                height: "16px",
                                radius: "xs",
                                style: {
                                    backgroundColor: selectedColorType
                                }
                            }),
                            /*#__PURE__*/ jsx(Icon, {
                                name: "dropdown",
                                size: "16",
                                color: "text.light.primary"
                            })
                        ]
                    })
                });
            }
        });
        $[12] = colors;
        $[13] = fontColor;
        $[14] = selectedColorType;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== backgroungColor || $[17] !== bgColors || $[18] !== isBgColorApplyed || $[19] !== selectedBgColorType) {
        t6 = backgroungColor && /*#__PURE__*/ jsx(DropdownButton, {
            menuItems: bgColors,
            variant: "tertiaryLight",
            verticalPosition: "bottom",
            horizontalPosition: "left",
            button: (t7)=>{
                const { onClick: onClick_1 } = t7;
                return /*#__PURE__*/ jsx(ToolbarButton, {
                    onClick: onClick_1,
                    tooltip: "\u0424\u043E\u043D \u0442\u0435\u043A\u0441\u0442\u0430",
                    children: /*#__PURE__*/ jsxs(Box, {
                        display: "flex",
                        alignItems: "center",
                        gap: "4",
                        children: [
                            /*#__PURE__*/ jsxs(Box, {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                children: [
                                    /*#__PURE__*/ jsx(Icon, {
                                        name: "marker_outline",
                                        size: "16",
                                        color: isBgColorApplyed ? "original.brand.primary" : "text.light.primary"
                                    }),
                                    /*#__PURE__*/ jsx(Box, {
                                        style: {
                                            backgroundColor: selectedBgColorType
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ jsx(Icon, {
                                name: "dropdown",
                                size: "16",
                                color: "text.light.primary"
                            })
                        ]
                    })
                });
            }
        });
        $[16] = backgroungColor;
        $[17] = bgColors;
        $[18] = isBgColorApplyed;
        $[19] = selectedBgColorType;
        $[20] = t6;
    } else t6 = $[20];
    let t7;
    if ($[21] !== t4 || $[22] !== t5 || $[23] !== t6) {
        t7 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            alignItems: "center",
            gap: "2",
            children: [
                t4,
                t5,
                t6
            ]
        });
        $[21] = t4;
        $[22] = t5;
        $[23] = t6;
        $[24] = t7;
    } else t7 = $[24];
    return t7;
};
export { FormatHeadingPlugin };
